import { render, staticRenderFns } from "./opinion.vue?vue&type=template&id=2882d395&scoped=true&"
import script from "./opinion.vue?vue&type=script&lang=js&"
export * from "./opinion.vue?vue&type=script&lang=js&"
import style0 from "./opinion.vue?vue&type=style&index=0&id=2882d395&scoped=true&lang=css&"
import style1 from "./opinion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2882d395",
  null
  
)

export default component.exports